import type React from 'react';
import { Icon } from '@iconify/react';
import { Button } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type OverviewEmptyBodyProps = {
    /** Literal testid prefix, e.g. `cash-runway`. */
    slot: string;
    /** What the metric is waiting for, in one sentence. */
    body: string;
    /** The single action that produces it. */
    cta: { label: string; icon: string; onPress: () => void };
};

/**
 * The body of a card that has nothing to measure yet: one sentence saying what
 * the metric needs, and the one action that supplies it.
 *
 * One CTA, never two. A card offering a choice is a card the reader has to
 * think about before doing the only useful thing on it — and the header above
 * has already told them what the card is for.
 */
export const OverviewEmptyBody: React.FC<OverviewEmptyBodyProps> = ({
    slot,
    body,
    cta,
}) => (
    <div className="flex flex-col items-start gap-3">
        <p className="text-sm text-muted">{body}</p>
        <Button
            onPress={cta.onPress}
            variant="primary"
            {...getNodeTestIdProp(`${slot}-empty-cta`)}
        >
            <Icon aria-hidden icon={cta.icon} />
            {cta.label}
        </Button>
    </div>
);
